import { Component } from '@angular/core';

@Component({
  selector: 'links-page',
  templateUrl: 'links.html'
})
export class LinksPage {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/links/links.ts